var map = {
	"./academicYear.js": "AKFW",
	"./adcharges.js": "76ON",
	"./admins.js": "dCtl",
	"./attendances.js": "9tFZ",
	"./auth.js": "CAWO",
	"./bankaccs.js": "pf9u",
	"./banktrans.js": "JvGE",
	"./billings.js": "lhtb",
	"./classes.js": "PLS0",
	"./discounts.js": "wEMe",
	"./docs.js": "bHCY",
	"./expenses.js": "bhKB",
	"./feepayments.js": "ND3V",
	"./feestrs.js": "E7IK",
	"./guardians.js": "oZp8",
	"./incomes.js": "cdbi",
	"./index.js": "zJdM",
	"./ledgeraccs.js": "JZ8T",
	"./marks.js": "XID/",
	"./message.js": "bEWe",
	"./oemployees.js": "VNQr",
	"./reports.js": "ptQp",
	"./settings.js": "mWh5",
	"./sms.js": "XLJ5",
	"./students.js": "UVfr",
	"./subjects.js": "JcTr",
	"./teachers.js": "C2Bc",
	"./terms.js": "PkpP",
	"./userroles.js": "R+bD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Z20x";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/store/modules nonrecursive \.js$
// module id = Z20x
// module chunks = 0